<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5 class="odx-title-5" i18n="@@alarmDeviceConfiguration.selectAlarmDevice.header">Alarmmittel auswählen</h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>
  <odx-content-box odxLayout="flex" class="flex-column flex-scroll">
    @if (project) {
      <div class="h-100" odxLayout="flex gap-none">
        @if (filteredAlarmDevices$ | async; as alarmDevices) {
          @if (alarmDevices.length > 0) {
            <div class="h-100">
              @if (safetyClass === SafetyClass.NON_EX) {
                <div class="h-100">
                  <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                    @for (alarmDevice of alarmDevices; track alarmDevice) {
                      <app-product-card
                        class="overflow-hidden"
                        [product]="alarmDevice"
                        [showCosts]="project.showCostFlag"
                        (select$)="checkboxSelectionChanged($event, alarmDevice)"
                        [isSelected]="checkIfSelected(alarmDevice)"
                        selectionMode="multi"
                      >
                        @if (alarmDevice.id) {
                          <div class="feature">
                            <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                            <p class="odx-text--small">{{ alarmDevice.id }}</p>
                          </div>
                        }
                      </app-product-card>
                    }
                  </div>
                </div>
              }
              <form [formGroup]="radioButtonForm">
                @if (safetyClass === SafetyClass.EX) {
                  <odx-radio-group formControlName="selectedAlarmDevice" required="true" class="h-100">
                    <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
                      @for (alarmDevice of alarmDevices; track alarmDevice) {
                        <app-product-card
                          class="overflow-hidden"
                          [product]="alarmDevice"
                          [showCosts]="project.showCostFlag"
                          [isSelected]="
                            checkedAlarmDevices.indexOf(alarmDevice) >= 0 ||
                            radioButtonForm.value.selectedAlarmDevice?.id === alarmDevice.id
                          "
                          (click)="
                            radioButtonForm.patchValue({
                              selectedAlarmDevice: alarmDevice,
                            })
                          "
                          (select$)="
                            radioButtonForm.patchValue({
                              selectedAlarmDevice: alarmDevice,
                            })
                          "
                          selectionMode="single"
                        >
                          @if (alarmDevice.id) {
                            <div class="feature">
                              <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                              <p class="odx-text--small">{{ alarmDevice.id }}</p>
                            </div>
                          }
                        </app-product-card>
                      }
                    </div>
                  </odx-radio-group>
                }
              </form>
            </div>
          } @else {
            <app-refresh-products-hint dataType="Alarmgeber" i18n-dataType="@@global.alarmDevices"></app-refresh-products-hint>
          }
        }
      </div>
    }
  </odx-content-box>
</div>
